import React from 'react';

import { getComponentClasses } from '../../utils/app';
import { Spinner } from '../Spinner';

export interface Props {
    isLoading: boolean;
    variations?: string[];
    spinnerVariations?: string[];
    children?: React.ReactNode;
}

export const LoadableElement = ({
    isLoading = false,
    variations = [],
    spinnerVariations = [],
    children,
}: Props) =>
    isLoading ? (
        <div className={getComponentClasses('loadable-element', variations)}>
            <div className="loadable-element__spinner">
                <Spinner variations={spinnerVariations} />
            </div>
        </div>
    ) : (
        <>{children}</>
    );

export default LoadableElement;
